import { UPDATE_INFO_ORDER } from '~/store/actions/OrderAction/type';

const initState = {
    infoOrder: {},
};

const OrderReducer = (state = initState, action) => {
    switch (action.type) {
        case UPDATE_INFO_ORDER: {
            let newState = { ...state };
            const newCart = action.payload;
            newState.infoOrder = newCart;
            return newState;
        }

        default:
            return state;
    }
};

export default OrderReducer;
